import { IonRange } from "@ionic/react";

const CustomSlider = ({ label, value, max, step, onChange, min }) => {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "0px",
        }}
      >
        <span
          style={{
            fontFamily: "Clash Grotesk",
            fontSize: "11px",
            fontWeight: 500,
            color: "#475569",
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontFamily: "Clash Grotesk",
            fontSize: "10px",
            fontWeight: 500,
            color: "#94a3b8",
            minWidth: "28px",
            textAlign: "right",
          }}
        >
          {typeof value === "number" ? (Number.isInteger(value) ? value : value.toFixed(2)) : value}
        </span>
      </div>
      <IonRange
        min={min}
        max={max}
        step={step}
        value={value}
        onIonKnobMoveEnd={(e) => {
          onChange(e.detail.value);
        }}
        style={{
          "--bar-background": "#e2e8f0",
          "--bar-background-active": "#e83e8c",
          "--bar-height": "3px",
          "--bar-border-radius": "4px",
          "--knob-background": "#e83e8c",
          "--pin-background": "#e83e8c",
          "--height": "16px",
          "--knob-border-radius": "50%",
          "--knob-size": "14px",
          "--knob-box-shadow": "0 1px 4px rgba(232, 62, 140, 0.3)",
          padding: "0",
          margin: "0",
        }}
      />
    </div>
  );
};

export default CustomSlider;
